// src/modules/fire/InsurerSettings/InsurerCardLabel.tsx
import * as React from "react";
import { Box, Stack, Switch, Typography, useTheme } from "@mui/material"; // Importamos useTheme

type Props = {
	name: string;
	enabled: boolean;
	onToggle?: () => void;
	Logo?: React.ComponentType<any>;
	dense?: boolean;
	logoHeight?: number;
	logoAspect?: number;
	avatarSize?: number;
};

export const InsurerCardLabel: React.FC<Props> = ({ name, enabled, onToggle, Logo, dense = false, logoHeight = 56, logoAspect = 2.8, avatarSize = 40 }) => {
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === "dark";

	const hasLogo = !!Logo;
	const logoWidth = Math.round(logoHeight * logoAspect);
	const logoFilterStyle = isDarkMode
		? {
				filter: "brightness(0) invert(1)",
		  }
		: {};

	const logoWrapperStyles = {
		width: logoWidth,
		minWidth: logoWidth,
		height: logoHeight,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	};

	return (
		<Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0, width: "100%" }}>
			{hasLogo ? (
				<Box
					sx={{
						...logoWrapperStyles,
						...logoFilterStyle,
					}}
				>
					<Box sx={{ width: "100%", "& svg, & img": { width: "100%", height: "auto", display: "block" } }}>
						<Logo height={logoHeight} />
					</Box>
				</Box>
			) : (
				<Box
					sx={{
						width: avatarSize,
						minWidth: avatarSize,
						height: avatarSize,
						borderRadius: "50%",
						bgcolor: "divider",
						flexShrink: 0,
					}}
				/>
			)}

			{/* Nome: só aparece quando NÃO houver logo */}
			{!hasLogo && (
				<Typography variant={dense ? "body2" : "body1"} noWrap title={name} sx={{ flex: 1, minWidth: 0 }}>
					{name}
				</Typography>
			)}

			{/* Empurra o switch para a direita quando não há nome (caso com logo) */}
			{hasLogo && <Box sx={{ flex: 1 }} />}

			<Switch size={dense ? "small" : "medium"} checked={enabled} onChange={onToggle} />
		</Stack>
	);
};
